import { z } from 'zod';

/** Un champ laissé vide arrive comme chaîne vide via FormData : à traiter comme absent. */
export function optionnel<T extends z.ZodTypeAny>(schema: T): z.ZodType<z.infer<T> | undefined> {
  return z.preprocess((v) => (v === '' ? undefined : v), schema.optional()) as z.ZodType<
    z.infer<T> | undefined
  >;
}

/** Même piège pour un nombre : `""` n'est pas un `number` optionnel. */
export function optionnelNombre(schema: z.ZodNumber): z.ZodType<number | undefined> {
  return z.preprocess((v) => {
    if (v === '' || v === undefined || v === null) return undefined;
    return typeof v === 'number' ? v : Number(v);
  }, schema.optional()) as z.ZodType<number | undefined>;
}

export const DATE_ISO = /^\d{4}-\d{2}-\d{2}$/;
